import { ANY_ROOM_TYPE } from 'pages/common/const';
import { facetsIds } from '../../../const';
import { LaminateInputs } from '../../../types';
import { getProjectConfigurationParameters } from './get-project-configuration-parameters';
import { getFacetsValues } from './get-facets-values';

export const getProjectUpdatedCustomEventPayload = (inputsData: LaminateInputs) => {
  const projectConfigurationParameters = getProjectConfigurationParameters(inputsData);
  const facets = [];

  if (inputsData.roomType && inputsData.roomType !== ANY_ROOM_TYPE) {
    facets.push(
      {
        id: facetsIds.THICKNESS,
        values: getFacetsValues(facetsIds.THICKNESS, inputsData.roomType),
      },
      {
        id: facetsIds.CLASS,
        values: getFacetsValues(facetsIds.CLASS, inputsData.roomType),
      },
      {
        id: facetsIds.WATER_RESISTANCE,
        values: getFacetsValues(facetsIds.WATER_RESISTANCE, inputsData.roomType),
      }
    );
  } else {
    facets.push(
      {
        id: facetsIds.THICKNESS,
        values: [],
      },
      {
        id: facetsIds.CLASS,
        values: [],
      },
      {
        id: facetsIds.WATER_RESISTANCE,
        values: [],
      }
    );
  }

  return {
    projectConfigurationParameters,
    facets,
  };
};
